/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { useEffect, useLayoutEffect, useState } from "react";
import classNames from "classnames/bind";
import { Pagination } from "components/LegacyUI/Pagination";
import useRefEffect from "hook/useRefEffect";
import { STUFFING_CHUNK } from "pages/hooks/Stuffing.hook";
import { ResponseContainer } from "store";
import { chunk } from "utils/helper";
import { generateId } from "utils/utils";
import { StuffingDetailedItem } from "./StuffingDetailedItem";
import styles from "./StuffingDetailed.module.scss";
const cn = classNames.bind(styles);

interface StuffingDetailedProps {
  stuffingData: ResponseContainer[];
  cargoesAttributes: any;
  options: any;
  pageHandler: (page: number) => void;
}

export const StuffingDetailed = ({ stuffingData, options, cargoesAttributes, pageHandler }: StuffingDetailedProps) => {
  const [top, setTop] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [paginationData, setPaginationData] = useState<ResponseContainer[][]>([]);

  const ref = useRefEffect((node: HTMLDivElement) => {
    if (!node) return;
    const top = node.scrollTop + node.getBoundingClientRect().top;
    setTop(top);
  }, []);

  useLayoutEffect(() => {
    setPaginationData(chunk(stuffingData, STUFFING_CHUNK));
  }, [stuffingData]);

  useEffect(() => {
    pageHandler(page);
    window.scrollTo({ top, behavior: "smooth" });
  }, [page]);

  return (
    <div ref={ref} className={styles["stuffing-detailed"]}>
      <header className={cn("stuffing-detailed__header")}>
        <Pagination currentPage={page} totalPages={paginationData.length} onChangePage={setPage} />
      </header>

      {paginationData[page - 1] &&
        paginationData[page - 1].map((item: ResponseContainer, i: number) => (
          <StuffingDetailedItem
            cargoesAttributes={cargoesAttributes}
            containerData={item}
            options={options}
            key={item.uid || generateId()}
            index={(page - 1) * STUFFING_CHUNK + i + 1}
          />
        ))}

      <footer className={cn("stuffing-detailed__footer")}>
        <Pagination currentPage={page} totalPages={paginationData.length} onChangePage={setPage} />
      </footer>
    </div>
  );
};
